import React from 'react';
import { FieldArrayProvider } from '../../../../helpers/formManager';
import { fieldNames } from '../../shared/configs/acceptanceForm';
import { DesksDataTracker } from '../../controllers/DesksDataTracker';
import DesksCol from './DesksCol';
import DeskSetupCol from './DeskSetupCol';
import { ImmutabilityChecksProvider } from './immutabilityChecksProvider';

const SetupDesks = ({ immutabilityChecks, allowClearClassicTime }) => {
  return (
    <FieldArrayProvider
      name={fieldNames.main.desks}
      rules={{ required: 'Добавьте столы' }}
      keyName="key"
    >
      <ImmutabilityChecksProvider checks={immutabilityChecks}>
        <DesksDataTracker>
          <DesksCol />
          <DeskSetupCol allowClearClassicTime={allowClearClassicTime} />
        </DesksDataTracker>
      </ImmutabilityChecksProvider>
    </FieldArrayProvider>
  );
};

export default SetupDesks;
